import {
  ACTIVE_AUCTION_STATUS,
  ACTIVE_TENDERING_STATUS,
  UNSUCCESSFUL_STATUS,
} from '@/constants/auction';

const STATUS_UI_MAP = {
  [UNSUCCESSFUL_STATUS]: {
    className: 'status-unsuccess',
    color: 'rgba(216, 28, 28, 0.26)',
  },
  [ACTIVE_TENDERING_STATUS]: {
    className: 'activeTendering',
    color: 'rgba(27, 99, 8, 0.23)',
  },
  [ACTIVE_AUCTION_STATUS]: {
    className: 'default-status',
    color: 'rgba(46, 127, 137, 0.41)',
  },
};

export function getAuctionStatusClass(status, fallback = '') {
  const ui = STATUS_UI_MAP[status];
  return ui ? ui.className : fallback;
}

export function getAuctionStatusColor(status, fallback = '#c4c4c44d') {
  const ui = STATUS_UI_MAP[status];
  return ui ? ui.color : fallback;
}
